import { render } from "./topup.vue?vue&type=template&id=1095fefe"
import script from "./topup.vue?vue&type=script&lang=js"
export * from "./topup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__